import { ScreenshotTools } from '@babylonjs/core/Misc/screenshotTools'
import { CameraAngle, ScreenShotCamera } from './Cameras'
import ModelViewer from './ModelViewer'

export class CameraSelector extends HTMLElement {
	setSelectedCamera(value: CameraAngle) {
		this.cameras.forEach(x => x.element.classList.remove('selected'))
		this.selectedCamera = this.cameras.find(x => x.angle == value)
		if (this.selectedCamera) this.selectedCamera.element.classList.add('selected')
	}

	viewer: ModelViewer
	selected: CameraAngle
	camera: ScreenShotCamera

	cameras = [
		{
			angle: CameraAngle.Front,
			element: document.createElement('img')
		},
		{
			angle: CameraAngle.Perspective,
			element: document.createElement('img')
		},
		{
			angle: CameraAngle.Side,
			element: document.createElement('img')
		},
		{
			angle: CameraAngle.Top,
			element: document.createElement('img')
		},
		{
			angle: CameraAngle.Top2,
			element: document.createElement('img')
		},
		{
			angle: CameraAngle.Detail,
			element: document.createElement('img')
		},
		{
			angle: CameraAngle.Engraving,
			element: document.createElement('img')
		},
		{
			angle: CameraAngle.Hinge,
			element: document.createElement('img')
		},
		{
			angle: CameraAngle.Diamond,
			element: document.createElement('img')
		}
	]

	selectedCamera: { angle: CameraAngle; element: HTMLImageElement }

	public constructor(viewer: ModelViewer) {
		super()
		this.viewer = viewer
		this.camera = new ScreenShotCamera()

		this.innerHTML = String.raw`<style>
        realtime-cameraselector {
            position: absolute;
            bottom: 0;
            left: 0;
            width:100%;
            display:flex;
            justify-content: center;
            pointer-events: none;
            user-select: none;
        }

        img {
            display: block;
            cursor: pointer;
            max-width: 100px;
            min-width: 0;
            aspect-ratio: 16 / 9;

            margin: 10px;
            display: grid;
            place-items: center;
            font-size: 30px;
            pointer-events: all;

            object-fit: cover;
            border-bottom: 5px solid rgba(255, 255, 255, 0);
            transition: border-color .5s;
            filter: grayscale(1);
        }

        img[src=""]{
            display:none
        }

        img.selected {
            border-bottom: 5px solid rgba(255, 255, 255, .5);
            transition: border-color .2s;
            filter: none;
        }

        .Precious img.selected {
            border-color: #baa07a;
        }
        </style>`

		// this.classList.add(this.viewer.theme)

		for (const camera of this.cameras) {
			camera.element.setAttribute('value', camera.angle)
			camera.element.setAttribute('alt', `click for ${camera.angle} view`)
			camera.element.onclick = e => {
				this.selected = camera.angle
				this.cameras.filter(x => x != camera).map(x => x.element.removeAttribute('class'))
				camera.element.classList.add('selected')
				this.selectedCamera = camera
				this.dispatchEvent(new Event('change'))
			}
			camera.element.onmouseup = e => { // Avoid closing customiser menu
				e.preventDefault()
				e.stopPropagation()
			}
		}
		this.viewer.scene.registerBeforeRender(() => {
			if (this.selectedCamera && (this.viewer.camera.inertialAlphaOffset || this.viewer.camera.inertialBetaOffset || this.viewer.camera.inertialRadiusOffset)) {
				this.selectedCamera.element.classList.remove('selected')
				this.selectedCamera = null
			}
		})
	}

	async getScreenshot(angle: CameraAngle, size) {
		// console.log("GET SCREENSHOT", angle)
		const t = performance.now()
		if (this.camera.transform(angle)) {
			const src = await ScreenshotTools.CreateScreenshotAsync(this.camera.getEngine(), this.camera, size, 'image/png', 0)
			return src
		}
		return ''

		// console.log("DONE2", angle)
	}

	async update() {
		this.className = this.viewer.theme
		const t = performance.now()
		await this.camera.getScene().whenReadyAsync()
		// console.log(`ready in ${Math.round(performance.now() - t)}ms`)
		// console.log("UPDATE SCREENSHOTS!!!")
		this.cameras.map(x => x.element.remove())
		const visibleCameras = this.viewer.settings.cameraSelectors.map(x => this.cameras.find(y => y.angle == x))
		// const visibleCameras = this.cameras.filter(x => this.viewer.settings.cameraSelectors.includes(x.angle))

		for (const camera of visibleCameras) {
			this.appendChild(camera.element)
		}
		// const prevMode = this.viewer.scene.fogMode

		const scale = .250 * window.devicePixelRatio
		// if(this.viewer.scene.fogMode) this.viewer.scene.fogMode = Scene.FOGMODE_NONE
		const size = { width: 1600 * scale, height: 900 * scale }

		const srcs: string[] = []
		for (const camera of visibleCameras) {
			srcs.push(await this.getScreenshot(camera.angle, size))
			// await new Promise(resolve => setTimeout(resolve, 100))
		}
		// console.log(`Generated ${srcs.length} screenshot${srcs.length ? "s" : ""} in ${Math.round(performance.now() - t)}ms`)
		visibleCameras.map((x, i) => x.element.src = srcs[i])
		// this.viewer.scene.fogMode = prevMode
	}
}
customElements.define('realtime-cameraselector', CameraSelector)
